export const enTeam = {
  "our": "OUR",
  "title": "TEAM",
  "subTitle": "TOGETHER, WE GO FURTHER",

  description:
    "Meet our exceptional team of experts who drive innovation and excellence at GCO. With diverse skills and extensive experience, we're committed to delivering cutting-edge solutions and transforming digital experiences.",
  name: {
    1: "Habib Ben Hadj Ali",
    2: "Hamza Regaeig",
    3: "Chahine Fehry",
    4:"Foued Raissi",
    5:"Eya Mhamed",
  },
  role: {
    1: "Ceo & Founder",
    2: "Sales Director & Co-Founder",
    3: " Graphic Designer UX/UI",
    4:"Full Stack Developer & System Administrator (Security & Performance Audit)"
  },
};
export const frTeam = {
  our: "NOTRE",
  title: "ÉQUIPE",
  subTitle: "ENSEMBLE, NOUS ALLONS PLUS LOIN",
  description:
    "Découvrez notre équipe exceptionnelle d'experts qui stimulent l'innovation et l'excellence chez GCO. Avec des compétences diversifiées et une expérience approfondie, nous nous engageons à fournir des solutions de pointe et à transformer les expériences numériques.",
  name: {
    1: "Habib Ben Hadj Ali",
    2: "Hamza Regaeig",
    3: "Chahine Fehry", 
    4: "Foued Raissi",
    5: "Eya Mhamed",
  },
  role: {
    1: "PDG & Fondateur",
    2: "Directeur Commercial & Co-Fondateur",
    3: "Designeur Graphique UX/UI", 
    4: "Développeur Full Stack & Administrateur Système (Sécurité & Audit de Performance)",

  },
};

export const nlTeam = {
  our: "ONS",
  title: "TEAM",
  subTitle: "SAMEN GAAN WE VERDER",

  description:
    "Maak kennis met ons uitzonderlijke team van experts die innovatie en uitmuntendheid bij GCO stimuleren. Met diverse vaardigheden en uitgebreide ervaring zetten we ons in voor het leveren van baanbrekende oplossingen en het transformeren van digitale ervaringen.",
  name: {
    1: "Habib Ben Hadj Ali",
    2: "Hamza Regaeig",
    3: "Chahine Fehry", 
    4: "Foued Raissi",
    5: "Eya Mhamed",
  },
  role: {
    1: "CEO & Oprichter",
    2: "Commercieel Directeur & Co-Oprichter",
    3: "Grafisch Ontwerper UX/UI",  
    4: "Full Stack Developer & Systeembeheerder (Beveiliging & Prestatie-audit)",
  },
};

export const deTeam = {
  our: "UNSER",
  title: "TEAM",
  subTitle: "ZUSAMMEN GEHEN WIR WEITER",
  description:
    "Lernen Sie unser außergewöhnliches Team von Experten kennen, die Innovation und Exzellenz bei GCO vorantreiben. Mit vielfältigen Fähigkeiten und umfangreicher Erfahrung setzen wir uns dafür ein, bahnbrechende Lösungen zu liefern und digitale Erlebnisse zu transformieren.",
  name: {
    1: "Habib Ben Hadj Ali",
    2: "Hamza Regaeig",
    3: "Chahine Fehry", 
    4: "Foued Raissi",
    5: "Eya Mhamed",
  },
  role: {
    1: "CEO & Gründer",
    2: "Vertriebsleiter & Mitbegründer",
    3: "Grafikdesigner UX/UI",  
    4: "Full Stack Developer & Systemadministrator (Sicherheit & Leistungsprüfung)",
  },
};